import type {
  StPoolRewardClaimStatus,
  StPoolRewardTargetAccount,
} from '../../../services/socialTradingService';

/**
 * Kept out of the service module so helpers (and their tests) do not load
 * axios just to read two enums.
 */
export const POOL_REWARD_CLAIM_STATUSES: readonly StPoolRewardClaimStatus[] = [
  'CLAIMABLE',
  'CLAIMING',
  'CLAIMED',
];

export const POOL_REWARD_TARGET_ACCOUNTS: readonly StPoolRewardTargetAccount[] = [
  'PERP',
  'PREDICT_MARGIN',
  'PREDICT_GRID',
];
